import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { TextCutter } from '../../TextCutter';
import { Tooltip, TooltipProps } from '../../Tooltip';

interface TextProps {
  lines?: number;
  value?: ReactNode;
  className?: string;
  tooltip?: Omit<TooltipProps, 'children'>;
}

export const Text = ({ value = '', lines, tooltip, className }: TextProps) => (
  <Tooltip {...tooltip} place={tooltip?.place || 'right'}>
    <TextCutter
      text={value}
      lines={lines}
      className={cn('max-w-[350px] min-w-[200px] text-base leading-4', className)}
      title={tooltip?.help ? '' : undefined} // ignore title when using tooltip
    />
  </Tooltip>
);
